import React from "react";
interface CameraProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: string;
}

const IconCamera: React.FC<CameraProps> = ({ className, width, height, fill }) => (
  <svg width={width} height={height} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="24.242" fill="#979797" />
    <path
      d="M26.08 31.14q2.083 0 3.542-1.459a4.84 4.84 0 0 0 1.459-3.542q0-2.083-1.459-3.542a4.84 4.84 0 0 0-3.542-1.458q-2.083 0-3.542 1.458a4.84 4.84 0 0 0-1.459 3.542q0 2.084 1.459 3.542a4.84 4.84 0 0 0 3.542 1.459m0-2.222a2.66 2.66 0 0 1-1.971-.806 2.66 2.66 0 0 1-.806-1.971q0-1.168.806-1.972a2.66 2.66 0 0 1 1.971-.806q1.167 0 1.971.806.807.805.807 1.971t-.806 1.972a2.66 2.66 0 0 1-1.973.806zm-8.888 6.11q-.916 0-1.57-.65a2.13 2.13 0 0 1-.653-1.57V19.48q0-.916.653-1.57.652-.65 1.57-.65h3.5l2.055-2.224h6.667l2.055 2.223h3.5q.916 0 1.57.651t.653 1.57v13.333q0 .916-.653 1.57a2.13 2.13 0 0 1-1.569.651z"
      fill="#fff"
    />
  </svg>
);
export default IconCamera;
